import React, {useEffect} from "react";
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from "react-router-dom";
import WebFrontLayout from "../../components/layouts/WebFrontLayout";

import HomePage from "./HomePage";
import AboutPage from "./AboutPage";
import ContactPage from "./ContactPage";
import CategoryPage from "./CategoryPage";
import ArticlePage from "./ArticlePage";

const WebFront = () => {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = t('title');
  }, [t])

  return (
    <ConfigProvider theme={{
      token: {
        fontSize: 16
      }
    }}>
      <WebFrontLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="menu/:menu_id/category/:category_id" element={<CategoryPage />} />
          <Route path="category/:category_id" element={<CategoryPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="article/:article_id" element={<ArticlePage />} />
        </Routes>
      </WebFrontLayout>
    </ConfigProvider>
  );
};

export default WebFront;